/** @jsxImportSource @emotion/react */
 import { css} from '@emotion/react'
 import { Table} from 'antd';
import { Pagination } from 'antd';

import { useState } from 'react';



export default function MemberLimits() {
  const [page,setPage] = useState(1);

  const data = [
    {
      key: '1',
      id: "1",
      username: 'Hlaing Min Aung',
      code : 873662,
      name: "test name",
      phNum: "09890666049",
      points: 100,
      action: {close: true,suspend: true,edit: true,view: true,statements: true},
    },
    {
      key: '2',
      id: "2",
      username: 'Ko Nyi',
      code: 232384,
      name: "test name",
      phNum: "09890666049",
      points: 100,
      action: {close: true,suspend: true,edit: true,view: true,statements: true},
    },
    {
      key: '3',
      id: "3",
      username: 'Zar Lin',
      code: 733540,
      name: "test name",
      phNum: "09890666049",
      points: 100,
      action: {close: true,suspend: true,edit: true,view: true,statements: true},
    },
    
  ];
  
  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'name',
    },
    {
      title: 'Phone No.',
      key: 'phNum',
      dataIndex: 'phNum',
    },
    {
      title: '5 starts Comm',
      key: 'fiveStartsComm',
      dataIndex: 'fiveStarsComm'
    },
    {
      title: '4 Stars Comm',
      key: 'fourStarsComm',
      dataIndex: 'fourStarsComm'
    },
    {
      title: '3 Stars Comm',
      key: 'threeStarsComm',
      dataIndex: 'threeStarsComm'
    },
    {
      title: 'Body Min Amount',
      key: 'bodyMinAmount',
      dataIndex: 'bodyMinAmount'
    },
    {
      title: 'Body MAX Amount',
      key: 'bodyMaxAmount',
      dataIndex: 'bodyMaxAmount'
    },
    {
      title: 'Mix Parlay Min Amount',
      key: 'mixParlayMinAmount',
      dataIndex: 'mixParlayMinAmount'
    },
    {
      title: 'Mix Parlay Max Amount',
      key: 'mixParlayMaxAmount',
      dataIndex: 'mixParlayMaxAmount'
    },
    {
      title: '2 Mix Parlay Comm',
      key: 'twoMixParlayComm',
      dataIndex: 'twoMixParlayComm'
    },
    {
      title: '3~8 Mix Parlay Comm',
      key: 'threeToEightMixParlayComm',
      dataIndex: 'threeToEightMixParlayComm'
    },
    {
      title: '9~11 Mix Parlay Comm',
      key: 'nineToEightMixParlayComm',
      dataIndex: 'nineToEightMixParlayComm'
    },
    {
      title: 'Body Per Match Limit',
      key: 'bodyPerMatchLimit',
      dataIndex: 'bodyPerMatchLimit'
    },

  
  ];
  return (
    <div>

      <div css={css`display: flex;justify-content: space-between;`}>
        <input placeholder='Search...' css={css`padding: 0.6rem 0.6rem;border-radius: 0.6rem;border: 1px solid grey;outline: none;&:focus {border-color: #5e35b1;}`} />

      </div>
      <Table scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={data} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} defaultCurrent={page} total={500} pageSize={10} showSizeChanger={false} onChange={(page) => setPage(page)} />
    </div>
  )
}
